import React from "react";
import CurriculumFramework from "./CurriculumFramework";

const UberAdminTemplate = () => {
  return (
    <div className="row">
      <div className="table-div">
        <CurriculumFramework />
      </div>
    </div>
  );
};

export default UberAdminTemplate;
